import React from 'react'
import PropTypes from 'prop-types'
import { dateTimeFormatter } from '../../utils/date'
import { existy } from '../../utils/helpers'
import iconPressure from '../../assets/icon-pressure-dark.svg'

// rows for a pressure monitor's last reading, from the location /last
// endpoint. Only v6.1+ readings carry a low/high, and pressure is then the
// sample window's average
export const getPressureReadingRows = ({
  pressure,
  lowPressure,
  highPressure,
}) => {
  const hasLowHigh = existy(lowPressure) || existy(highPressure)

  return [
    {
      key: 'pressure',
      label: hasLowHigh ? 'Average Pressure' : 'Pressure',
      value: pressure,
    },
    { key: 'lowPressure', label: 'Low Pressure', value: lowPressure },
    { key: 'highPressure', label: 'High Pressure', value: highPressure },
  ].filter(({ value }) => existy(value))
}

export const formatPressure = (value, units) =>
  `${parseFloat(value).toFixed(3)} ${units}`

const PressureMonitorLatestReading = ({ reading }) => (
  <div className="mb3">
    <div className="b mb3 tc">{dateTimeFormatter(reading.time, true)}</div>
    <ul className="pl0 mb0 list">
      {getPressureReadingRows(reading).map(({ key, label, value }) => (
        <li key={key} className="flex justify-between mb1">
          <div className="flex items-center">
            <img src={iconPressure} alt={label} className="w1 h1 mr2" />
            <span className="b">{label}</span>
          </div>
          {formatPressure(value, reading.units)}
        </li>
      ))}
    </ul>
  </div>
)

PressureMonitorLatestReading.propTypes = {
  reading: PropTypes.shape({
    time: PropTypes.string.isRequired,
    pressure: PropTypes.number,
    lowPressure: PropTypes.number,
    highPressure: PropTypes.number,
    units: PropTypes.string,
  }).isRequired,
}

export default PressureMonitorLatestReading
